import React, { useEffect, useMemo, useState } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useTranslations } from "@jugl-web/utils";
import LoadingAnimation from "./assets/loading.json";

export const AILoadingTile: React.FC = () => {
  const { t } = useTranslations();
  const [index, setIndex] = useState(0);

  const texts = useMemo(
    () => [
      `${t({
        id: "ai-loading-tile-component.searching-for-matching-data",
        defaultMessage: "Searching for Matching Data",
      })}...`,
      `${t({
        id: "ai-loading-tile-component.analyzing-tasks",
        defaultMessage: "Analyzing Tasks",
      })}...`,
      `${t({
        id: "ai-loading-tile-component.collecting-task-info",
        defaultMessage: "Collecting Task Info",
      })}...`,
      `${t({
        id: "ai-loading-tile-component.structuring-the-information",
        defaultMessage: "Structuring the Information",
      })}...`,
      `${t({
        id: "ai-loading-tile-component.adding-final-touch",
        defaultMessage: "Adding final touch",
      })}...`,
      `${t({
        id: "ai-loading-tile-component.almost-there",
        defaultMessage: "Almost there",
      })}!`,
    ],
    [t]
  );

  useEffect(() => {
    if (index >= texts.length - 1) return undefined;

    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2500);

    return () => clearInterval(interval);
  }, [index, texts.length]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex w-max items-center gap-2.5 rounded-xl bg-[linear-gradient(221deg,_#FFE2FD_-27.22%,_#E6F4FF_111.38%)] py-2 px-2.5">
        <Lottie
          options={{
            animationData: LoadingAnimation,
          }}
          width={46}
          height={40}
        />
        <span className="font-secondary bg-gradient-to-r from-[#115285] to-[#A21A63] bg-clip-text text-sm leading-[140%] text-transparent">
          {texts[index]}
        </span>
      </div>
      <div className="flex flex-col gap-6">
        {[...new Array(5)].map((_, idx) => (
          <div
            key={+idx}
            className="h-12 animate-pulse rounded-[10px] bg-[#F9F9F9]"
            style={{ width: `${50 + Math.floor(Math.random() * 51)}%` }}
          />
        ))}
      </div>
    </div>
  );
};
